import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-default--sprite",
  "use": "checkbox-default--sprite-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkbox-default--sprite\">\n\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t<g>\n\t\t\t<rect x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"2\">\n\t\t\t</rect>\n\t\t</g>\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol